import { render, staticRenderFns } from "./InstructionGroup.vue?vue&type=template&id=4ccbef56&scoped=true&"
import script from "./InstructionGroup.vue?vue&type=script&lang=js&"
export * from "./InstructionGroup.vue?vue&type=script&lang=js&"
import style0 from "./InstructionGroup.vue?vue&type=style&index=0&id=4ccbef56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccbef56",
  null
  
)

export default component.exports